/**
 * Allowed hosts for creator “Google Map link” fields (keep in sync with backend-core
 * `src/app/utils/googleMapsLink.ts`). Short links are accepted as-is.
 */
function isGoogleMapsUrl(url: URL): boolean {
  const host = url.hostname.toLowerCase();
  const path = url.pathname.toLowerCase();

  if (host === "maps.app.goo.gl") return true;
  if (host === "maps.google.com") return true;
  if (host === "goo.gl" && path.includes("/maps")) return true;
  if (host === "g.co" && path.startsWith("/maps")) return true;
  if (host === "m.google.com" && path.startsWith("/maps")) return true;

  if (host === "google.com" || host === "www.google.com") {
    return path.startsWith("/maps");
  }

  if (/^www\.google\.[a-z.]+$/i.test(host) || /^google\.[a-z.]+$/i.test(host)) {
    return path.startsWith("/maps");
  }

  return false;
}

/**
 * Trim; if non-empty and missing scheme, prefix https://.
 * Empty after trim → ''.
 * Non-empty must parse as URL and pass Google Maps host allowlist.
 */
export function normalizeGoogleMapsLink(raw: unknown): string {
  if (raw == null) return "";
  const t = String(raw).trim();
  if (!t) return "";

  const withScheme = /^https?:\/\//i.test(t) ? t : `https://${t}`;

  let url: URL;
  try {
    url = new URL(withScheme);
  } catch {
    throw new Error("Invalid map URL");
  }

  if (!isGoogleMapsUrl(url)) {
    throw new Error("Map link must be a Google Maps URL");
  }

  return url.href;
}
